import * as React from 'react';
import styled from 'styled-components';

export enum ToastType {
  default,
  success,
  error,
  warning,
  info
}

const defaultProps = {
  type: ToastType.default
};
type IProps = {
  type: ToastType;
  children?: any
} & typeof defaultProps;

const Container = styled.div<{ type: ToastType }>`
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => props.theme.defaultFontSize};
  color: ${props => props.theme.lightTextColor};

  border-radius: 2px;  

  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 
                 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 
                 0px 2px 1px -1px rgba(0, 0, 0, 0.12);

  -webkit-box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 
                      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 
                      0px 2px 1px -1px rgba(0, 0, 0, 0.12);

  -moz-box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 
                    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 
                    0px 2px 1px -1px rgba(0, 0, 0, 0.12);

  padding: 14px;
  display: block;  
  line-height: 150%;  
  
  background: ${props => {
    switch (props.type) {
      case ToastType.default:
        return props.theme.secondaryColor;
      case ToastType.error:
        return props.theme.errorColor;
      case ToastType.warning:
        return props.theme.warningColor;
      case ToastType.success:
        return props.theme.approvedColor;
      case ToastType.info:
        return props.theme.secondaryLightColor;
      default:
        return props.theme.secondaryColor;
    }
  }}`;

export const Toast: React.FC<IProps> = (props: IProps) => (
  <Container type={props.type}>
    {props.children}
  </Container>
);

Toast.defaultProps = defaultProps;